import { toast } from 'sonner';
import { MapPin, Copy } from 'lucide-react';

// =============================================================================
// TrackingLinkRow — one framed bar in the Allocation box, same frame as the
// "Change allocation" button:
//   [ 📍 Live tracking ●                     | ⧉ Copy link ]
// Left part opens the customer's tracking page, right part copies its link.
// Only shows once a chauffeur is allocated; hidden on cancelled / no-show.
// =============================================================================

const TRACK_BASE_URL = 'https://partner.lanzcts.com';
const LIVE = ['en_route', 'arrived', 'on_journey'];

export function TrackingLinkRow({ booking }) {
    if (!booking?.tracking_token || !booking?.allocated_chauffeur_id) return null;
    if (['cancelled', 'no_show'].includes(booking.status)) return null;

    const url = `${TRACK_BASE_URL}/track/${booking.tracking_token}`;
    const isLive = LIVE.includes(booking.status);

    async function copy() {
        try {
            await navigator.clipboard.writeText(url);
            toast.success('Tracking link copied');
        } catch {
            window.prompt('Copy this link:', url);
        }
    }

    return (
        <div className="flex items-stretch w-full rounded-md border border-paper-border bg-white overflow-hidden">
            <button
                type="button"
                onClick={() => window.open(url, '_blank', 'noopener')}
                className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium text-ink hover:bg-canvas"
                title="Open the customer's live tracking page"
            >
                <MapPin className="h-4 w-4 text-ink-subtle" />
                Live tracking
                {isLive && (
                    <span className="inline-flex items-center gap-1 text-2xs font-medium text-emerald-700">
                        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-500" />
                        Live now
                    </span>
                )}
            </button>
            <button
                type="button"
                onClick={copy}
                className="inline-flex items-center gap-1 px-3 py-2 text-xs text-ink-subtle hover:text-ink hover:bg-canvas border-l border-paper-border"
                title="Copy the customer's tracking link"
            >
                <Copy className="h-3.5 w-3.5" />
                Copy link
            </button>
        </div>
    );
}
